<template>
	<div class="py-4" id="footer">
		<div class="content">
			<p class="m-0">
				&copy; {{ year }} All Rights Reserved | Built with &#128151; by
				<a href="https://frankofficial.netlify.com" target="_blank">
					Alegu Franklin Ominyi</a
				>
			</p>
		</div>
	</div>
</template>

<script>
import { ref } from "vue";

export default {
	setup() {
		let year = ref();
		let date = new Date();

		year.value = date.getFullYear();

		return { year };
	},
};
</script>

<style scoped>
#footer {
	background-color: #000;
	width: 100%;
	border-top: 1px solid #fff;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 16px;
	padding: 10px 0 !important;
}

.content {
	color: #fff;
	text-align: center;
}

a {
	transition: color 0.7s ease-in-out;
	color: #9f6ba0;
	font-weight: 500;
}
a:hover {
	color: #ca2c92;
}
</style>
